// library imports
import { useEffect, useState, useContext } from "react";
import { Flex, Row, Col } from "antd";
// hook imports
import useFetch from "../../hooks/useFetch";
// context imports
import { IndexContext } from "../../context/IndexContext";
// component imports
import DataTable from "../common/DataTable";

export default function SavingReportOverallSummary({
  dates,
  isSearchClicked,
  loading,
  setLoading,
  tableData,
  setTableData,
  chartData,
  setChartData,
}) {
  // fetch wrapper
  const [fetchWrapper] = useFetch();

  // load index context
  const { siteSelected } = useContext(IndexContext);

  // title year
  const [yearTitle, setYearTitle] = useState("");

  // summary table columns
  const columns = [
    {
      title: "Saving Type",
      dataIndex: "SavingType",
      key: "SavingType",
      width: "50%",
    },
    {
      title: "Saving",
      dataIndex: "Saving",
      key: "Saving",
      width: "50%",
    },
  ];

  /** API to get saving report overall summary (table data and chart data) */
  function getSavingReportOverallSummary() {
    setLoading(true);
    setYearTitle("");

    fetchWrapper({
      endpoint_url: "saving_report_microgrid/getSavingReportOverallSummary",
      method: "GET",
      set_content_type_header: false,
      params: {
        site_id: siteSelected,
        start_date: dates[0].startOf("month").format("YYYY-MM-DD"),
        end_date: dates[1].endOf("month").format("YYYY-MM-DD"),
      },

      onSuccess: (response) => {
        setTableData(response.data.table_data);
        setYearTitle(response.data.year);
      },

      onFinish: () => {
        setLoading(false);
      },
    });
  }

  useEffect(() => {
    if (isSearchClicked === true && dates?.[0] && dates?.[1] && siteSelected) {
      getSavingReportOverallSummary();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearchClicked, dates]);

  useEffect(() => {
    setYearTitle("");
  }, [siteSelected]);

  return (
    <div className="h-100 w-100">
      <Flex justify="center">
        <h2>Summary for the Year {yearTitle}</h2>
      </Flex>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <DataTable
            table_data={tableData}
            table_column={columns}
            loading={loading}
          />
        </Col>
      </Row>
    </div>
  );
}
